import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Engagement from './icon-engagement.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Engagement {...validProps} />;
}
SvgComponent.iconName = 'engagement';

/**
 * @deprecated This is a legacy icon
 */
export const EngagementIcon = svgIconWrapper(SvgComponent);
